// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"624":"builder","642":"universal-cropper","778":"company-settings"}[chunkId] || chunkId) + ".js";
};